import {useCallback} from 'react';

import {AppsSelection} from '@web-catalog/types';

import {useGetVkId} from '@web-catalog/store/auth';

import {logTmrEvent} from '@web-catalog/utils/analytics';
import {getFeaturingAnalyticsType} from '@web-catalog/utils/analytics/useFeaturingAnalytics';

export const useLogCompilationSwipe = (
  selection: AppsSelection | null | undefined,
  selectionNumber: number,
) => {
  const getVkId = useGetVkId();
  const onSwipe = useCallback(
    (direction: 'left' | 'right') => {
      logTmrEvent({
        logEvent: `compilation.Swipe${direction === 'right' ? 'Right' : 'Left'}.swipe`,
        params: {
          compilation_id: selection?.id,
          compilation_name: selection?.title?.value,
          compilation_type: getFeaturingAnalyticsType(
            selection?.type,
            selection?.displayType,
          ),
          compilation_num: selectionNumber,
          vk_id: getVkId(),
        },
      });
    },
    [selection, getVkId, selectionNumber],
  );
  return onSwipe;
};
